import styled from 'styled-components';
const Wrap = styled.footer`border-top:1px solid ${({theme})=>theme.border}; padding:24px 0; margin-top:40px;`;
export default function Footer(){
  return (
    <Wrap>
      <div className="container" style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
        <div>© {new Date().getFullYear()} MOMV LLC</div>
        <div>info@momv.com.ua · +38 099 368 23 20</div>
      </div>
    </Wrap>
  );
}
